module.exports = __webpack_public_path__ + "img/animate.fb283e87.jpg";